<template>
  <v-layout
    wrap
    column
    justify-start
    :class="!bMini ? 'viewLayoutWrapper MiniPadding' : 'viewLayoutWrapper'"
  >
    <!-- Start title -->
    <p class="SectionTitle">Proveedores</p>
    <!-- End title -->
    <!-- Start search component -->
    <search-providers :mdUp="mdUp" :smUp="smUp"  > </search-providers>
    <!-- End search component -->
    
    <!-- Start table component -->
    <table-providers :mdUp="mdUp" :smUp="smUp"> </table-providers>
    <edit-providers :mdUp="mdUp" :smUp="smUp"> </edit-providers>
    <!--
                <v-layout row justify-center>
        <v-pagination
          color="primary"
          v-model="iCurrentPage"
          :length="iPageNumber"
        ></v-pagination>
      </v-layout>-->
    <!-- End table component -->
  </v-layout>
</template>
<script>
export default {
  components: {
    // import search component
    SearchProviders: () => import("../../components/views/Providers/Search"),
    // import search component
    TableProviders: () => import("../../components/views/Providers/Table"),
    // import edit dialog
    EditProviders: () => import("../../components/views/Providers/Edit"),
  },
  props: {
    // import texts from admin
    texts: Object,
    mdUp: Boolean,
    smUp: Boolean,
    bMini: Boolean,
  },
  computed: {
    // section texts
    sectionTxt() {
      return this.texts.providers;
    },
  },
};
</script>
